import React, { useState } from 'react'
import { sendPasswordResetEmail } from 'firebase/auth'
import { Link, useNavigate } from 'react-router-dom'
import { FirebaseError } from 'firebase/app'
import {
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import { useSnackbar } from '../contexts/SnackbarContext'
import { auth } from '../firebase'
import AuthLayout from '../layouts/AuthLayout'

export const PasswordReset = () => {
  const [email, setEmail] = useState('')
  const [isEmailError, setIsEmailError] = useState(false)
  const [emailErrorText, setEmailErrorText] = useState('')
  const [dialogOpen, setDialogOpen] = useState(false)
  const navigate = useNavigate()
  const { showSnackbar } = useSnackbar()

  const convertToJapanese = (errorMessage: string) => {
    switch (errorMessage) {
      case 'auth/invalid-email':
        return 'メールアドレスの形式が正しくありません'
      case 'auth/user-disabled':
        return 'このユーザーは無効化されています'
      case 'auth/user-not-found':
        return 'ユーザーが見つかりません'
      case 'auth/operation-not-allowed':
        return 'この操作は許可されていません'
      default:
        return '不明なエラーが発生しました'
    }
  }

  const handlePasswordReset = async () => {
    if (!email) {
      setIsEmailError(true)
      setEmailErrorText('メールアドレスを入力してください')
      return
    }
    setEmailErrorText('')
    setIsEmailError(false)

    try {
      await sendPasswordResetEmail(auth, email)
      setDialogOpen(true)
    } catch (e: unknown) {
      setIsEmailError(true)
      if (e instanceof FirebaseError) {
        const newErrorMessage = convertToJapanese(e.code)
        showSnackbar(newErrorMessage, 'error')
      } else {
        showSnackbar('不明なエラーが発生しました', 'error')
      }
    }
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
    navigate('/login')
  }

  return (
    <>
      <AuthLayout title="パスワード再設定" backgroundImageUrl="/password-reset.png">
        <TextField
          id="outlined-basic"
          label="メールアドレス"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={isEmailError}
          helperText={emailErrorText || ' '}
          fullWidth
          sx={{ margin: '12px auto 0' }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handlePasswordReset}
          size="large"
          sx={{
            width: '100%',
            fontWeight: 'bold',
            fontSize: '16px',
            margin: '16px auto 32px',
          }}
        >
          パスワード再設定メールを送信
        </Button>

        <Button
          color="info"
          variant="text"
          component={Link}
          to="/login"
          sx={{
            fontWeight: 'bold',
          }}
        >
          ログイン画面に戻る
        </Button>
      </AuthLayout>

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            パスワード再設定メールを送信しました
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            メール内のリンクをクリックし、パスワードを再設定してください。その後、ログイン可能になります。
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>

    </>
  )
}
